import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AuthContextProvider from "./contexts/AuthContext";
import Home from "./Pages/Home";
import Logout from "./Components/Users/Logout.jsx";
import Signup from "./Components/Users/Signup.jsx";
import SignupDoctor from "./Components/Users/SignupDoctor.jsx";
import SignupAdmin from "./Components/Users/SignupAdmin.jsx";
import SignupSecre from "./Components/Users/SignupSecre";
import BlockList from "./Components/ScheduleList/BlockList";
import Profile from "./Components/Profile/Profile";
import UpMedia from "./Components/Media/UpMedia"
import Contact from "./Components/Contact/Contact"
import ContactList from "./Components/ContactList/ContactList"
import Formulario from "./Components/Formulario/Formulario";
import Profesionales from "./Components/Profesionales/Profesionales";
import List from "./Components/UsersList/List"
import ForgotPassword from "./Components/Users/ForgotPassword";
import Feriados from "./Components/Feriados/Feriados";

function Routes() {
  return (
    <BrowserRouter>
      <AuthContextProvider>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/register" component={Signup} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/signupdoctor" component={SignupDoctor} />
          <Route exact path="/signupadmin" component={SignupAdmin} />
          <Route exact path="/signupsecre" component={SignupSecre} />
          <Route exact path="/blocklist" component={BlockList} />
          <Route exact path="/adminslist" component={() => <List lista="admins" titulo="Administradores" />} />
          <Route exact path="/userslist" component={() => <List lista="usuarios" titulo="Usuarios" />} />
          <Route exact path="/doctorslist" component={() => <List lista="doctors" titulo="Doctores" />} />
          <Route exact path="/secreslist" component={() => <List lista="secres" titulo="Secretaria" />} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/files" component={UpMedia} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/feriados" component={Feriados} />
          <Route exact path="/contactlist" component={ContactList} />
          <Route exact path="/formulario" component={Formulario} />
          <Route exact path="/profesionales" component={Profesionales} />
          <Route exact path="/forgot" component={ForgotPassword} />
        </Switch>
      </AuthContextProvider>
    </BrowserRouter>
  );
}

export default Routes;
